// Core Rulebook Special Substances and Items.
const specialSubstances = [];

export default specialSubstances;
